module.exports = __webpack_public_path__ + "images/views-upsell/map.b57fb00e345ff64bfdd6.svg";